export default {
  'initial.dataset.candlestick': function () {
    return {
      'rect.appearing': (inputJSON) => {
        return [{
          initialAttr: {
            y: inputJSON.attr.y + inputJSON.attr.height,
            height: 0
          },
          slot: 'plot'
        }];
      },
      'group.appearing': (inputJSON) => {
        if (inputJSON.attr.name === 'label-group') {
          return [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: 'final'
          }];
        }
        return [{
          initialAttr: {
            opacity: 1
          },
          finalAttr: {
            opacity: 1
          },
          slot: 'final'
        }];
      },
      '*': null
    };
  },
  'initial.dataset.volume': function () {
    return {
      'rect.appearing': (inputJSON) => {
        return [{
          initialAttr: {
            y: inputJSON.attr.y + inputJSON.attr.height,
            height: 0
          },
          slot: 'plot'
        }];
      },
      '*': null
    };
  }
};
